var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9945 6.96304C16.3499 9.15177 14.863 11.2141 12.6735 11.5694C10.4839 11.9246 8.42082 10.4383 8.06541 8.24962C7.70999 6.0609 9.19686 3.99858 11.3864 3.6433C13.576 3.28802 15.639 4.77432 15.9945 6.96304ZM9.5 13C7.567 13 6 14.567 6 16.5V19.4C6 19.9523 6.44772 20.4 7 20.4H17C17.5523 20.4 18 19.9523 18 19.4V16.5C18 14.567 16.433 13 14.5 13H9.5Z",
    fill: "url(#paint0_linear_468_75537)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_75537",
    x1: 7.37023,
    y1: 0.369829,
    x2: 28.9574,
    y2: 28.0666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59E3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BD64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorUser);
export default __webpack_public_path__ + "static/media/color-user.72caf4db2e808264c5a73d76b9b045e0.svg";
export { ForwardRef as ReactComponent };